const date = new Date();
const options = { day: '2-digit', month: 'long', year: 'numeric' };
const currentYearPlaceholder = date.toLocaleDateString('en-GB', options);

export default currentYearPlaceholder;
